module.exports = __webpack_public_path__ + "img/viewpoint1.16c4a912.png";